import 'webagent/css/global.css';
import 'webagent/css/main.css';
import 'webagent/css/webagent.css';
import 'webagent/css/webagent_css3.css';
import 'webagent/css/webagent_user.css';
import 'webagent/css/global.errors.css';
import 'webagent/css/user/login.css';

import 'webassets/css/Reset.css';
import 'webassets/css/Icons.css';
import 'webassets/css/Gui.css';

import '../../css/color-scheme.css';

import 'expose-loader?Nis!../../globals/Nis';
import 'expose-loader?Page!../../globals/Page';

import 'webagent/javascripts/Nis.Login';
import 'webassets/javascripts/Nis.Gui';

import * as moment from 'moment-timezone';

const login = new Nis.Login({
  guid: __DATA.QueryStringGuid,
  organisation: __DATA.QueryStringOrganisation,
  username: __DATA.QueryStringUsername,
});

login.init($('#login-container'));

$(`#userGuessedTimeZoneField`).val(moment.tz.guess());



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/entry/page/login.ts